import Loader from "../../../../components/Loader";
import { useQuery } from "@tanstack/react-query";
import MetricsAPI from "../../../../api/Metrics/Metrics.js";
import { useTheme } from "styled-components";
import DenseBarChart from "./DenseBarChart";

interface CaseLead {
  email: string;
  full_name: string;
  first_name: string;
  last_name: string;
  total: number;
  user_id: number;
}

const CaseLeadChart = () => {
  const theme: any = useTheme();
  const { data: caseLeadData } = useQuery({
    queryKey: ["activeCasesPerLead"],
    queryFn: () => MetricsAPI.getMetrics({ metric: "activeCasesPerLead" }),
    select: (data) => data?.data?.activeCasesPerLead,
  });

  if (!caseLeadData) return <Loader />;

  // The metric returns every active user in `user_id` order, including users with
  // no open cases, so rank them here rather than showing creation order.
  const sorted = [...caseLeadData].sort(
    (a: CaseLead, b: CaseLead) => b.total - a.total
  );

  return (
    <DenseBarChart
      labels={sorted.map((d: CaseLead) => d.full_name)}
      values={sorted.map((d: CaseLead) => d.total)}
      seriesName="Total"
      color={theme.palette.primary.main}
    />
  );
};

export default CaseLeadChart;
